// extracted by mini-css-extract-plugin
export default {"modalWrapper":"bVeZGfzLPB9UmZv7wDAm"};